export default {
  state: {
    detail: null,
    urlQuery: null
  },
  mutations: {
    setRabDetail(state, payload) {
      state.detail = payload
    },
    setRabPageQuery(state, payload) {
      console.log('setRabPageQuery>>>', payload)
      state.urlQuery = payload
    }
  },
  actions: {},
  getters: {
    getRabDetail(state) {
      return state.detail
    },
    getRabPageQuery(state) {
      return state.urlQuery
    }
  }
}
